import { POST } from 'dealer-sagas/src/consts/methods'
import apiCall from '../apiCall'

interface CreateTransportParams {
  offerId: number
  description: string
  speditionId: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createTransport = async ({ offerId, description, speditionId }: CreateTransportParams): Promise<any> => {
  const endpoint = '/api/v2/transports'
  const params = { id: offerId, description, spedition_id: speditionId }
  return await apiCall({ endpoint, params, method: POST })
}
